import * as basicLightbox from 'basiclightbox'

/**
 *
 * @param {Node} btn the DOM Node triggering the opening of the lightbox, typically a button
 * @param {String} targetClass the CSS class that identifies the lightbox content (defaults to the data-lightbox property of the trigger button)
 * @returns {Object} the lightbox instance
 */
function createLightbox(btn, targetClass) {
	// the value of data-lightbox contains the CSS class of the lightbox element
	targetClass = targetClass || btn.dataset['lightbox']
	const targetLightbox = document.querySelector(targetClass)
	const targetCloseBtn = targetLightbox.querySelectorAll('.j-lightbox__close')

	const instance = basicLightbox.create(targetLightbox, {
		onShow: (instance) => {
			document.body.classList.add('has-lightbox-open')
		},
		onClose: (instance) => {
			document.body.classList.remove('has-lightbox-open')
		},
	})

	btn.addEventListener('click', function () {
		instance.show()
	})

	// event listener on button click to close instance
	targetCloseBtn.forEach((el) =>
		el.addEventListener('click', function () {
			instance.close()
		})
	)

	return instance
}

function initLightboxes() {
	document.querySelectorAll('[data-lightbox]').forEach(el => createLightbox(el))
}

initLightboxes()

export { createLightbox }
